import { useContext } from 'react'
import { FeedbackNudgeContext, type FeedbackNudgeContextValue } from './FeedbackNudgeContext'

export function useFeedbackNudge(): FeedbackNudgeContextValue {
  const context = useContext(FeedbackNudgeContext)
  if (!context) throw new Error('useFeedbackNudge must be used within FeedbackNudgeProvider')
  return context
}
